import type {
  OzonetelInitializeEventPayload,
  OzonetelInitializePayload,
} from '../../consts/ozonetel/sdk';

export function getOzonetelInitializePayload({
  customerId,
  payload,
}: {
  customerId: string;
  payload?: OzonetelInitializeEventPayload;
}): OzonetelInitializePayload | undefined {
  const customer = customerId.trim();
  const agentid = payload?.agentid.trim() ?? '';
  const phoneNumber = payload?.phoneNumber.trim() ?? '';
  const normalizedPin = payload?.pin ?? Number.NaN;

  if (!customer || !agentid || !phoneNumber || !Number.isFinite(normalizedPin)) {
    return undefined;
  }

  return {
    customer,
    agentid,
    phoneNumber,
    pin: normalizedPin,
    sip: true,
  };
}
